import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
    selector: 'cml-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService) { }

  async ngOnInit() {
    if (!this.authService.isAuthenticated()) {
      setTimeout(() => {
        if (!this.authService.isAuthenticated()) {
          this.login();
        }
      }, 1000);
    } else {
      this.router.navigate(['']); // todo zmena na url, ze ktere jsem prisel
    }
  }

  login() {
    this.authService.login();
  }

}
